import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

function SugarCost() {
  const [data, setData] = useState([]); // Store data from API
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [fromDate, setFromDate] = useState(""); // From date state
  const [toDate, setToDate] = useState(""); // To date state

  // Fetch data from the API when the component mounts or when the dates change
  const fetchData = async () => {
    if (!toDate) {
      alert("Please select both 'From' and 'To' dates.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Construct the API URL with the selected date range
      const response = await axios.get(
        `https://webcore.hunzagroupofindustries.com.pk/api/SugarCost?tDate=${toDate}&CompId=2`
      );
      setData(response.data); // Set the fetched data in state
    } catch (err) {
      setError("Failed to fetch data: " + err.message);
    } finally {
      setLoading(false); // Set loading state to false once the request completes
    }
  };

  const formatNumber = (num) => {
    // Ensure the number is a valid number, then round it to 2 decimal places
    const formattedNumber = parseFloat(num).toFixed(2);
    return new Intl.NumberFormat().format(formattedNumber);
  };
  

  // Define the column headers and their corresponding API fields
  const products = [
    { name: "Crushing", columns: ["CrushingOnDate"] },
    { name: "Sugar Recovery % ", columns: ["RecOnDate"] },
    { name: "Production", columns: ["Production"] },

  ];
  const p2 = [
  
    {
      name: "Average Cost /40 kgs",
      columns: ["OnDateAvgCost"],
    },
    {
        name: "Raw Material Cost",
        columns: ["RMCost"],
      },
  ];
  const revenue = [
    {
      name: "Molasses Produced",
      columns: ["MolProduced"],
    },
    {
        name: "Molasses Rate",
        columns: ["MolRate"],
      },
      {
        name: "Molasses Revenue",
        columns: ["MolRevenue"],
      },
      {
        name: "Mud Produced",
        columns: ["MudProduced"],
      },
      {
        name: "Mud Rate",
        columns: ["MudRate"],
      },
   
      {
        name: "Mud Revenue",
        columns: ["MudRevenue"],
      },
      {
        name: "Estimate Bagasse Saved On Date",
        columns: ["EstimateBagasseSavedOD"],
      },
      {
        name: "Bagasse Rate",
        columns: ["BagasseRate"],
      },
      {
        name: "Bagasse Revenue",
        columns: ["BagasseRevenue"],
      },
   
  ];
  const CostExByRev = [
    { name: "Cost of Sugar After Excl. By Product Revenue", columns: ["CostExByRev"] },
   
  ];

  const Overheads = [
   
    {
        name: "Conversion",
        columns: ["OHConv"],
      },
      {
        name: "Administration",
        columns: ["OHAdmin"],
      },
      {
        name: "Selling",
        columns: ["OHSell"],
      },
      {
        name: "Other Sugarcane Cost",
        columns: ["OHOCC"],
      },
     
  ];
  const CostAfterAddingOverhead=[
    {
        name: "Cost of Sugar after Adding Overheads ",
        columns: ["CostB4Taxes"],
      },
  ]
  
  const CostAfterTaxes = [
    { name: "Cost of Sugar After Adding Taxes", columns: ["CostAfterTaxes"] },
   
  ];
  const CPK = [
    { name: "Cost Per kg of Sugar", columns: ["CostPerKG"] },
   
  ];
 
  return (
    <div>
      <h3 className="text-center mb-4">Sugar Cost </h3>

      {/* Date Selection Input */}

      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <label htmlFor="toDate" className="form-label">
            To Date:
          </label>
          <input
            type="date"
            id="toDate"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-4">
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>

      {/* Error Handling */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Table with Data */}
      {!loading && data.length > 0 && (
        <div className="row">
          <div className="col-sm-12 ">
            <div className="table-responsive mt-3">
              <table className="table table-bordered table-hover table-sm">
                <thead className="table-success">
                  <tr className="bg-success">
                    <th >Date</th>
                    <th className="text-end">{toDate}</th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr className="table-info" >
                    <td>  <strong>Production</strong></td>
                  
                    <td></td>
                  </tr>
                  
                  {products.map((product, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{product.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][product.columns[0]])}
                      </td>

                      {/* To Date value */}
                     
                    </tr>
                  ))}
                   <tr className="table-info" >
                    <td>   <strong>Raw Material Cost</strong></td>
                  
                    <td></td>
                  </tr>
                 
                  {p2.map((p2, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{p2.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][p2.columns[0]])}
                      </td>

                      {/* To Date value */}
                     
                    </tr>
                  ))}
                  <tr className="table-info">
                    <td>
                    <strong>Revenue From By Product</strong>
                    </td>
                 <td>

                 </td>
                  </tr>
                  {revenue.map((revenue, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{revenue.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][revenue.columns[0]])}
                      </td>

                      {/* To Date value */}
                     
                    </tr>
                  ))}
                
                  {CostExByRev.map((CostExByRev, index) => (
                    <tr className="table-info" key={index}>
                      {/* Product Name */}
                      <td>{CostExByRev.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CostExByRev.columns[0]])}
                      </td>

                      {/* To Date value */}
                     
                    </tr>
                  ))}
                   <tr>
                    <td>
                    <strong>Overheads</strong>{" "}
                    </td>
                    <td>

                    </td>
                  
                  </tr>
                  {Overheads.map((Overheads, index) => (
                    <tr key={index}>
                      {/* Product Name */}
                      <td>{Overheads.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][Overheads.columns[0]])}
                      </td>

                      {/* To Date value */}
                    
                    </tr>
                  ))}
                   
                  {CostAfterAddingOverhead.map((CostAfterAddingOverhead, index) => (
                    <tr className="table-info" key={index}>
                      {/* Product Name */}
                      <td>{CostAfterAddingOverhead.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CostAfterAddingOverhead.columns[0]])}
                      </td>

                      {/* To Date value */}
                    
                    </tr>
                  ))}
                     {CostAfterTaxes.map((CostAfterTaxes, index) => (
                    <tr  className="table-info" key={index}>
                      {/* Product Name */}
                      <td>{CostAfterTaxes.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CostAfterTaxes.columns[0]])}
                      </td>

                      {/* To Date value */}
                    
                    </tr>
                  ))}
                     {CPK.map((CPK, index) => (
                    <tr className="table-warning" key={index}>
                      {/* Product Name */}
                      <td>{CPK.name}</td>

                      {/* On Date value */}
                      <td className="text-end">
                        {formatNumber(data[0][CPK.columns[0]])}
                      </td>

                      {/* To Date value */}
                    
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Loading Indicator */}
      {loading && <div className="text-center">Loading...</div>}

      {/* No Data Available */}
      {!loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available
        </div>
      )}
    </div>
  );
}

export default SugarCost;
